// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * EMRbyMD global typography system.
 *
 * Single source of truth for font family, type scale, line height, and weight.
 * Every stylesheet and component should consume these tokens (or the matching
 * Tailwind \`text-*\` utilities declared in tailwind.config.js) instead of
 * hard-coding px values, so future pages cannot drift.
 *
 * Scale bands (target ranges from the typography specification):
 *   page title      20-22px   section title 16-18px   card title 15-16px
 *   body / table    14px      label 13-14px           button 13-14px
 *   helper          12-13px   metadata 11-12px
 *
 * 12px is never the default size. Sizes below 12px are reserved for
 * genuinely incidental chrome (grid axis rulers, demo-data flags).
 */

:root {
    /* Family ------------------------------------------------------------ */
    --emr-font-sans: Arial, "Helvetica Neue", Helvetica, "Liberation Sans",
        "Segoe UI", sans-serif;
    --emr-font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
        "Liberation Mono", "Courier New", monospace;

    /* Size -------------------------------------------------------------- */
    --emr-type-page-title: 21px;
    --emr-type-page-title-compact: 18px; /* narrow-viewport page title */
    --emr-type-section-title: 17px;
    --emr-type-card-title: 15px;
    --emr-type-body: 14px;
    --emr-type-table: 14px;
    --emr-type-table-head: 13px;
    --emr-type-table-dense: 13px; /* wide matrices that cannot afford 14px */
    --emr-type-label: 13px;
    --emr-type-button: 14px;
    --emr-type-button-compact: 13px; /* toolbar / in-row buttons */
    --emr-type-helper: 13px;
    --emr-type-metadata: 12px;
    --emr-type-micro: 11px; /* rulers, demo-data flags only */

    /* Line height ------------------------------------------------------- */
    --emr-leading-page-title: 1.2;
    --emr-leading-heading: 1.25;
    --emr-leading-card-title: 1.3;
    --emr-leading-body: 1.45;
    --emr-leading-compact: 1.35;

    /* Weight ------------------------------------------------------------ */
    --emr-weight-body: 400;
    --emr-weight-label: 500;
    --emr-weight-title: 600;
}

/*
 * Reusable typography classes mirroring the tokens above, for markup that is
 * not Tailwind-driven. Tailwind consumers use the matching \`text-*\` utilities
 * (text-page-title, text-card-title, text-label, …) declared in
 * tailwind.config.js, which resolve to the same sizes and line heights.
 *
 * Declared as plain rules (not @layer components) because this file is
 * @imported and therefore processed without the @tailwind directives.
 */
.emr-type-page-title {
    font-size: var(--emr-type-page-title);
    font-weight: var(--emr-weight-title);
    line-height: var(--emr-leading-page-title);
}

.emr-type-section-title {
    font-size: var(--emr-type-section-title);
    font-weight: var(--emr-weight-title);
    line-height: var(--emr-leading-heading);
}

.emr-type-card-title {
    font-size: var(--emr-type-card-title);
    font-weight: var(--emr-weight-title);
    line-height: var(--emr-leading-card-title);
}

.emr-type-body {
    font-size: var(--emr-type-body);
    font-weight: var(--emr-weight-body);
    line-height: var(--emr-leading-body);
}

.emr-type-label {
    font-size: var(--emr-type-label);
    font-weight: var(--emr-weight-label);
    line-height: var(--emr-leading-compact);
}

.emr-type-table {
    font-size: var(--emr-type-table);
    font-weight: var(--emr-weight-body);
    line-height: var(--emr-leading-compact);
}

.emr-type-table-head {
    font-size: var(--emr-type-table-head);
    font-weight: var(--emr-weight-title);
    line-height: var(--emr-leading-card-title);
}

.emr-type-button {
    font-size: var(--emr-type-button);
    font-weight: var(--emr-weight-label);
    line-height: var(--emr-leading-page-title);
}

.emr-type-helper {
    font-size: var(--emr-type-helper);
    font-weight: var(--emr-weight-body);
    line-height: var(--emr-leading-body);
}

.emr-type-metadata {
    font-size: var(--emr-type-metadata);
    font-weight: var(--emr-weight-body);
    line-height: var(--emr-leading-compact);
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-typography.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;IACI,wEAAwE;IACxE;8BAC0B;IAC1B;mDAC+C;;IAE/C,wEAAwE;IACxE,2BAA2B;IAC3B,mCAAmC,EAAE,+BAA+B;IACpE,8BAA8B;IAC9B,2BAA2B;IAC3B,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B,EAAE,0CAA0C;IACxE,sBAAsB;IACtB,uBAAuB;IACvB,+BAA+B,EAAE,6BAA6B;IAC9D,uBAAuB;IACvB,yBAAyB;IACzB,sBAAsB,EAAE,iCAAiC;;IAEzD,wEAAwE;IACxE,6BAA6B;IAC7B,2BAA2B;IAC3B,6BAA6B;IAC7B,wBAAwB;IACxB,2BAA2B;;IAE3B,wEAAwE;IACxE,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;;;;;;;;EAQE;AACF;IACI,qCAAqC;IACrC,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;IACpC,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA;IACI,+BAA+B;IAC/B,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;IACpC,uCAAuC;AAC3C;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;IACnC,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;IACrC,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA;IACI,iCAAiC;IACjC,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;IACnC,mCAAmC;IACnC,uCAAuC;AAC3C","sourcesContent":["/*\n * EMRbyMD global typography system.\n *\n * Single source of truth for font family, type scale, line height, and weight.\n * Every stylesheet and component should consume these tokens (or the matching\n * Tailwind `text-*` utilities declared in tailwind.config.js) instead of\n * hard-coding px values, so future pages cannot drift.\n *\n * Scale bands (target ranges from the typography specification):\n *   page title      20-22px   section title 16-18px   card title 15-16px\n *   body / table    14px      label 13-14px           button 13-14px\n *   helper          12-13px   metadata 11-12px\n *\n * 12px is never the default size. Sizes below 12px are reserved for\n * genuinely incidental chrome (grid axis rulers, demo-data flags).\n */\n\n:root {\n    /* Family ------------------------------------------------------------ */\n    --emr-font-sans: Arial, \"Helvetica Neue\", Helvetica, \"Liberation Sans\",\n        \"Segoe UI\", sans-serif;\n    --emr-font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,\n        \"Liberation Mono\", \"Courier New\", monospace;\n\n    /* Size -------------------------------------------------------------- */\n    --emr-type-page-title: 21px;\n    --emr-type-page-title-compact: 18px; /* narrow-viewport page title */\n    --emr-type-section-title: 17px;\n    --emr-type-card-title: 15px;\n    --emr-type-body: 14px;\n    --emr-type-table: 14px;\n    --emr-type-table-head: 13px;\n    --emr-type-table-dense: 13px; /* wide matrices that cannot afford 14px */\n    --emr-type-label: 13px;\n    --emr-type-button: 14px;\n    --emr-type-button-compact: 13px; /* toolbar / in-row buttons */\n    --emr-type-helper: 13px;\n    --emr-type-metadata: 12px;\n    --emr-type-micro: 11px; /* rulers, demo-data flags only */\n\n    /* Line height ------------------------------------------------------- */\n    --emr-leading-page-title: 1.2;\n    --emr-leading-heading: 1.25;\n    --emr-leading-card-title: 1.3;\n    --emr-leading-body: 1.45;\n    --emr-leading-compact: 1.35;\n\n    /* Weight ------------------------------------------------------------ */\n    --emr-weight-body: 400;\n    --emr-weight-label: 500;\n    --emr-weight-title: 600;\n}\n\n/*\n * Reusable typography classes mirroring the tokens above, for markup that is\n * not Tailwind-driven. Tailwind consumers use the matching `text-*` utilities\n * (text-page-title, text-card-title, text-label, …) declared in\n * tailwind.config.js, which resolve to the same sizes and line heights.\n *\n * Declared as plain rules (not @layer components) because this file is\n * @imported and therefore processed without the @tailwind directives.\n */\n.emr-type-page-title {\n    font-size: var(--emr-type-page-title);\n    font-weight: var(--emr-weight-title);\n    line-height: var(--emr-leading-page-title);\n}\n\n.emr-type-section-title {\n    font-size: var(--emr-type-section-title);\n    font-weight: var(--emr-weight-title);\n    line-height: var(--emr-leading-heading);\n}\n\n.emr-type-card-title {\n    font-size: var(--emr-type-card-title);\n    font-weight: var(--emr-weight-title);\n    line-height: var(--emr-leading-card-title);\n}\n\n.emr-type-body {\n    font-size: var(--emr-type-body);\n    font-weight: var(--emr-weight-body);\n    line-height: var(--emr-leading-body);\n}\n\n.emr-type-label {\n    font-size: var(--emr-type-label);\n    font-weight: var(--emr-weight-label);\n    line-height: var(--emr-leading-compact);\n}\n\n.emr-type-table {\n    font-size: var(--emr-type-table);\n    font-weight: var(--emr-weight-body);\n    line-height: var(--emr-leading-compact);\n}\n\n.emr-type-table-head {\n    font-size: var(--emr-type-table-head);\n    font-weight: var(--emr-weight-title);\n    line-height: var(--emr-leading-card-title);\n}\n\n.emr-type-button {\n    font-size: var(--emr-type-button);\n    font-weight: var(--emr-weight-label);\n    line-height: var(--emr-leading-page-title);\n}\n\n.emr-type-helper {\n    font-size: var(--emr-type-helper);\n    font-weight: var(--emr-weight-body);\n    line-height: var(--emr-leading-body);\n}\n\n.emr-type-metadata {\n    font-size: var(--emr-type-metadata);\n    font-weight: var(--emr-weight-body);\n    line-height: var(--emr-leading-compact);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
